import './PolicyStyles.css';
import { exportToWord } from '../utils/exportToWord';

const ReturnToWorkPolicy = ({
  clientName,
  companyNumber,
  clientAddress,
  effectiveDate,
  hrContact,
  occupationalHealthContact,
}) => {
  const handleExportToWord = () => {
    const policyContent = document.getElementById('policy-content');
    exportToWord(policyContent.innerHTML, "Return_to_Work_Policy.docx");
  };

  return (
    <div className="policy-container" id="policy-content">
      <h3 className="policy-title">Return to Work Policy</h3>

      <p className="policy-details"><strong>Company Name:</strong> {clientName || "[Insert Company Name]"}</p>
      <p className="policy-details"><strong>Company Number:</strong> {companyNumber || "[Insert Company Number]"}</p>
      <p className="policy-details"><strong>Company Address:</strong> {clientAddress || "[Insert Company Address]"}</p>
      <p className="policy-details"><strong>Policy Effective Date:</strong> {effectiveDate || "[Insert Effective Date]"}</p>

      <h4 className="section-title">1. Purpose</h4>
      <p className="section-content">
        {clientName || "The Company"} is committed to supporting employees returning to work after sickness or injury, ensuring a safe, supportive, and sustainable transition back to their duties.
      </p>

      <h4 className="section-title">2. Scope</h4>
      <p className="section-content">
        This policy applies to all employees who have been absent due to illness, injury, or medical conditions and are returning to work.
      </p>

      <h4 className="section-title">3. Return to Work Procedure</h4>
      <ul>
        <li>Upon notification of return, a return-to-work interview will be scheduled to discuss the employee’s health, fitness, and any adjustments needed.</li>
        <li>Risk assessments will be conducted where appropriate to identify any hazards or requirements for reasonable adjustments.</li>
        <li>Occupational health referrals may be made to support employee wellbeing and provide medical guidance.</li>
        <li>Managers and HR will collaborate with employees to plan phased or modified returns if necessary.</li>
      </ul>

      <h4 className="section-title">4. Employee Responsibilities</h4>
      <ul>
        <li>Notify their manager or HR promptly about their return date and any ongoing health concerns.</li>
        <li>Participate actively in return-to-work meetings and cooperate with any assessments or support arrangements.</li>
      </ul>

      <h4 className="section-title">5. Manager Responsibilities</h4>
      <ul>
        <li>Facilitate return-to-work interviews in a sensitive and supportive manner.</li>
        <li>Ensure any agreed adjustments or phased return plans are implemented and reviewed regularly.</li>
        <li>Maintain confidentiality and respect employee privacy throughout the process.</li>
      </ul>

      <h4 className="section-title">6. Confidentiality</h4>
      <p className="section-content">
        All medical information and discussions will be treated confidentially and shared only on a need-to-know basis.
      </p>

      <h4 className="section-title">7. Support and Wellbeing</h4>
      <p className="section-content">
        {clientName || "The Company"} encourages employees to access available wellbeing resources, including occupational health services and Employee Assistance Programmes (EAP).
      </p>

      <h4 className="section-title">8. Monitoring and Review</h4>
      <p className="section-content">
        The policy and return-to-work processes will be monitored and reviewed annually to ensure effectiveness and compliance with relevant legislation.
      </p>

      <h4 className="section-title">Contact Information</h4>
      <ul>
        <li><strong>Human Resources:</strong> {hrContact || "[Insert Contact Number]"}</li>
        <li><strong>Occupational Health:</strong> {occupationalHealthContact || "[Insert Contact Number]"}</li>
      </ul>

      <h4 className="section-title">Employee Acknowledgment and Signature</h4>
      <p>I confirm that I have read, understood, and agree to comply with the Return to Work Policy.</p>
      <p>Employee Name: _________________________</p>
      <p>Employee Signature: _________________________</p>
      <p>Date: _________________________</p>

      <h4 className="section-title">Management Approval and Signature</h4>
      <p>This policy has been approved by senior management and is now in effect.</p>
      <p>Manager/Officer Name: _________________________</p>
      <p>Title: _________________________</p>
      <p>Signature: _________________________</p>
      <p>Date: _________________________</p>

      <div className="mt-4 text-center">
        <button
          onClick={handleExportToWord}
          className="bg-green-600 text-white px-6 py-2 rounded hover:bg-green-700 transition"
        >
          Export to Word
        </button>
      </div>
    </div>
  );
};

export default ReturnToWorkPolicy;
